import { db } from '../components/Dexie';
import { log } from './loggingService';

/**
 * Synchronizes banners with the remote API.
 * @param {boolean} force - If true, clears local data and forces a full sync.
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const syncTechyShopBanners = async (force = true) => {
  try {
    if (force) {
      log("Reset banner techyshop locali in corso...", 'INFO');
      await db.techyshop_banner.clear();
    }
    
    log("Avvio download banner dal server...", 'INFO');

    const response = await fetch('https://deadapi.techysumo.it/techyshop/listBanner', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({})
    });
    
    const result = await response.json();
    
    if (result.result && Array.isArray(result.details)) {
      const normalizedBanners = result.details.map(b => ({
        ...b,
        id: parseInt(b.id),
        attivo: (b.attivo == 1 || b.attivo === true || String(b.attivo).toLowerCase() === 'true') ? 1 : 0,
        ordinamento: parseInt(b.ordinamento) || 0
      }));
      
      await db.techyshop_banner.bulkPut(normalizedBanners);
      log(`Sincronizzati ${normalizedBanners.length} banner.`, 'INFO');

      return { success: true, message: `Sincronizzati ${normalizedBanners.length} banner con successo!` };
    } else {
      throw new Error(result.text || "Errore durante il download dei banner.");
    }
  } catch (error) {
    log("Errore durante la sincronizzazione dei banner:", 'ERROR', error);
    return { success: false, message: `Errore: ${error.message}` };
  }
};
